import { z } from 'zod'
import { type CompanyDocument } from '~/domain/dashboard/company/models/CompanyDocument'
import { DocumentType } from '~/domain/shared/document/models/Document'
import { reverseMap } from '~/global/utils/TypeHelper'

export const CompanyDocumentDTO = z.object({
  type: z.enum(['cpf', 'rg', 'cnpj', 'ie', 'im', 'custom']),
  identify: z.string().nullish()
})
export type CompanyDocumentDTO = z.infer<typeof CompanyDocumentDTO>

export function mapDTOToCompanyDocument (dto: CompanyDocumentDTO): CompanyDocument {
  return {
    type: documentTypeMap[dto.type],
    value: dto.identify ?? undefined
  }
}

export function mapCompanyDocumentToDTO (model: CompanyDocument): CompanyDocumentDTO {
  return {
    // FIXME Não tem o tipo `CUSTOM` na API, acho que nem faz sentido termos no nosso modelo tbm
    type: reverseMap(documentTypeMap)[model.type] ?? 'cnpj',
    identify: model.value ?? undefined
  }
}

const documentTypeMap: Record<CompanyDocumentDTO['type'], DocumentType> = {
  cnpj: DocumentType.CNPJ,
  cpf: DocumentType.CPF,
  ie: DocumentType.IE,
  im: DocumentType.IM,
  rg: DocumentType.RG,
  custom: DocumentType.Custom
}
